import { Container as MuiContainer, ContainerProps } from '@mui/material';

const Container = ({ children, ...rest }: ContainerProps) => (
  <MuiContainer component="main" sx={{ mt: 2, mb: 2 }} {...rest}>{children}</MuiContainer>

);
export default Container;
